import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

interface Props {
  data: Array<object> | undefined;
  emptyMessage: string;
  CardComponent: React.ComponentType<{ option: object }>;
  gridWidth?: number;
}

const CardsView = (props: Props) => {
  const { data, emptyMessage, CardComponent, gridWidth, ...rest } = props;

  if (isEmpty(data)) {
    // No data
    return (
      <Typography variant="body1" color="primary">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {data?.map(option => (
        /* @ts-ignore */
        <Grid item key={option.id} xs={gridWidth || 12} md={gridWidth || 6} lg={gridWidth || 4}>
          <CardComponent option={option} {...rest} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CardsView;
